"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerList = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const CheckBox_1 = require("../../CheckBox");
const Field_1 = require("../../Form/Field");
const Icon_1 = require("../../Icon");
const LoadingOverlay_1 = require("../../LoadingOverlay");
const Table_1 = require("../../Table");
const messages_1 = require("./messages");
const tableManagerListConfig_1 = require("./tableManagerListConfig");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'manager-list';
class ManagerListClass extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            searchText: this.props.searchText || '',
            isActiveOnly: this.props.isActiveOnly || false,
        };
        this.submitForm = () => {
            if (!this.props.isSubmitButtonDisable) {
                const { searchText, isActiveOnly, } = this.state;
                this.props.onSubmit({
                    searchText,
                    isActiveOnly,
                });
            }
        };
        this.handleSetSort = (data) => {
            var _a;
            (_a = this.props) === null || _a === void 0 ? void 0 : _a.setSort(data);
        };
        this.handleSubmitForm = (event) => {
            event.preventDefault();
            this.submitForm();
        };
        this.handleSearchTextChange = (event) => {
            const { value } = event.target;
            this.setState({ searchText: value }, this.submitForm);
        };
        this.handleIsOnlyActiveChange = () => {
            this.setState({ isActiveOnly: !this.state.isActiveOnly }, this.submitForm);
        };
    }
    render() {
        const { modificators, isLoading, isDirty, tableColumns, tableData, sortBy, sortOrder, } = this.props;
        const { searchText, isActiveOnly } = this.state;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const loadingOverlayProps = {
            isLoading: isLoading || isDirty,
            hideLoader: !isLoading,
            loadingMessage: isLoading ? undefined : '',
            modificators: 'top',
        };
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("form", { className: `${className}__form`, onSubmit: this.handleSubmitForm },
                react_1.default.createElement("div", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
                react_1.default.createElement("div", { className: `${className}__search` },
                    react_1.default.createElement(Field_1.FormField, { modificators: ['search'], placeholder: this.props.intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: this.handleSearchTextChange, value: searchText })),
                react_1.default.createElement("div", { className: `${className}__buttons` }),
                react_1.default.createElement("div", { className: `${className}__checkboxes` },
                    react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Manager/List:IsActiveOnly', defaultMessage: 'Active only' }), modificators: ['inline'], onChange: this.handleIsOnlyActiveChange, checked: isActiveOnly || false }))),
            react_1.default.createElement("div", { className: `${className}__list` },
                react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { ...loadingOverlayProps },
                    react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sortBy, defaultSortOrder: sortOrder, manualSortBy: true, setSort: this.handleSetSort, tableModificators: utils_1.tableModificators })))));
    }
}
ManagerListClass.defaultProps = {
    children: null,
    loading: false,
    isSubmitButtonDisable: false,
    onSubmit: () => { },
    tableColumns: tableManagerListConfig_1.tableManagerListDefaultConfig,
    tableData: [],
    sortBy: undefined,
    sortOrder: undefined,
    setSort: () => { },
};
exports.ManagerList = (0, react_intl_1.injectIntl)(ManagerListClass);
//# sourceMappingURL=index.js.map